import { render, staticRenderFns } from "./FurtherProductInformation.vue?vue&type=template&id=029294ba&"
import script from "./FurtherProductInformation.vue?vue&type=script&lang=js&"
export * from "./FurtherProductInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports